/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Legacy
 * Mercatus Legacy ILM
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { InlineResponse2002 } from '../model';
/**
 * PreferencesApi - axios parameter creator
 * @export
 */
export const PreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get associated assumptions with selected state for entity type
         * @param {number} entityTypeId EntityTypeId to fetch models for.
         * @param {number} orgId OrgId to fetch models for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTypeCategoryWithAssumptionSelections: async (entityTypeId: number, orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('getEntityTypeCategoryWithAssumptionSelections', 'entityTypeId', entityTypeId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getEntityTypeCategoryWithAssumptionSelections', 'orgId', orgId)
            const localVarPath = `/preferences/categoriesassumptions/{entityTypeId}/{orgId}`
                .replace(`{${"entityTypeId"}}`, encodeURIComponent(String(entityTypeId)))
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add or replace assumptions selected for an entity type
         * @param {number} entityTypeId EntityTypeId to fetch models for.
         * @param {number} orgId OrgId to fetch models for.
         * @param {boolean} selected Selected or not
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssumptionSelections: async (entityTypeId: number, orgId: number, selected: boolean, requestBody?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('updateAssumptionSelections', 'entityTypeId', entityTypeId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateAssumptionSelections', 'orgId', orgId)
            // verify required parameter 'selected' is not null or undefined
            assertParamExists('updateAssumptionSelections', 'selected', selected)
            const localVarPath = `/preferences/entityassumptions/{entityTypeId}/{selected}/{orgId}`
                .replace(`{${"entityTypeId"}}`, encodeURIComponent(String(entityTypeId)))
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"selected"}}`, encodeURIComponent(String(selected)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreferencesApi - functional programming interface
 * @export
 */
export const PreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get associated assumptions with selected state for entity type
         * @param {number} entityTypeId EntityTypeId to fetch models for.
         * @param {number} orgId OrgId to fetch models for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityTypeCategoryWithAssumptionSelections(entityTypeId: number, orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityTypeCategoryWithAssumptionSelections(entityTypeId, orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add or replace assumptions selected for an entity type
         * @param {number} entityTypeId EntityTypeId to fetch models for.
         * @param {number} orgId OrgId to fetch models for.
         * @param {boolean} selected Selected or not
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssumptionSelections(entityTypeId: number, orgId: number, selected: boolean, requestBody?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssumptionSelections(entityTypeId, orgId, selected, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PreferencesApi - factory interface
 * @export
 */
export const PreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get associated assumptions with selected state for entity type
         * @param {number} entityTypeId EntityTypeId to fetch models for.
         * @param {number} orgId OrgId to fetch models for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTypeCategoryWithAssumptionSelections(entityTypeId: number, orgId: number, options?: any): AxiosPromise<InlineResponse2002> {
            return localVarFp.getEntityTypeCategoryWithAssumptionSelections(entityTypeId, orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add or replace assumptions selected for an entity type
         * @param {number} entityTypeId EntityTypeId to fetch models for.
         * @param {number} orgId OrgId to fetch models for.
         * @param {boolean} selected Selected or not
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssumptionSelections(entityTypeId: number, orgId: number, selected: boolean, requestBody?: Array<string>, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.updateAssumptionSelections(entityTypeId, orgId, selected, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreferencesApi - object-oriented interface
 * @export
 * @class PreferencesApi
 * @extends {BaseAPI}
 */
export class PreferencesApi extends BaseAPI {
    /**
     * 
     * @summary Get associated assumptions with selected state for entity type
     * @param {number} entityTypeId EntityTypeId to fetch models for.
     * @param {number} orgId OrgId to fetch models for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public getEntityTypeCategoryWithAssumptionSelections(entityTypeId: number, orgId: number, options?: any) {
        return PreferencesApiFp(this.configuration).getEntityTypeCategoryWithAssumptionSelections(entityTypeId, orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add or replace assumptions selected for an entity type
     * @param {number} entityTypeId EntityTypeId to fetch models for.
     * @param {number} orgId OrgId to fetch models for.
     * @param {boolean} selected Selected or not
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public updateAssumptionSelections(entityTypeId: number, orgId: number, selected: boolean, requestBody?: Array<string>, options?: any) {
        return PreferencesApiFp(this.configuration).updateAssumptionSelections(entityTypeId, orgId, selected, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
